import { render, staticRenderFns } from "./NuevoReglamentoCirculacion.vue?vue&type=template&id=05a111cb&scoped=true&"
var script = {}
import style0 from "./NuevoReglamentoCirculacion.vue?vue&type=style&index=0&id=05a111cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a111cb",
  null
  
)

export default component.exports